// extracted by mini-css-extract-plugin
export default {"section_wrapper":"sectionWithHeading-module--section_wrapper--SUe7c","section_content":"sectionWithHeading-module--section_content--jhTc-"};